export * from '@entities/canh-tac/canh-tac.service';
export * from '@entities/canh-tac/canh-tac/canh-tac.component';
export * from '@entities/canh-tac/canh-tac-detail/canh-tac-detail.component';
export * from '@entities/canh-tac/canh-tac-dialog/canh-tac-dialog.component';
export * from '@entities/canh-tac/hanh-dong/hanh-dong.component';
export * from '@entities/canh-tac/canh-tac.route';
